exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#DeliveryForm[data-v-2dd5b431]{height:40em;padding-bottom:100vh}#DeliveryForm div[data-v-2dd5b431]{margin:0;position:absolute;top:35%;left:50%;margin-right:-50%;transform:translate(-50%,-50%)}label[data-v-2dd5b431]{display:inline-block;margin-bottom:.5rem;text-align:left;width:-webkit-fill-available;margin-left:4vh}.input-text[data-v-2dd5b431]{width:85%;margin-bottom:20px}.place-name[data-v-2dd5b431]{transform:none!important;position:unset!important;margin-top:-4px!important;margin-left:4px!important;font-size:10px}.button[data-v-2dd5b431]{padding:.5em;margin:2em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2dd5b431","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/DeliveryForm.vue
// module id = 536
// module chunks = 0